module.exports = __webpack_public_path__ + "static/media/user-search.a62318d5.svg";